import React from 'react';

function choices(config) {
  return (config.choices || []).map((choice) =>
    typeof choice === 'string' ? { value: choice, label: choice } : choice,
  );
}

export function BasicField({ fieldId, config, value, onChange }) {
  const id = `field-${fieldId}`;
  const commonProps = {
    id,
    value: value || '',
    required: Boolean(config.required),
    onChange: (event) => onChange(fieldId, event.target.value),
  };

  if (config.type === 'textarea') {
    return <textarea {...commonProps} maxLength={config.max_length || undefined} />;
  }

  if (config.type === 'select') {
    return (
      <select {...commonProps}>
        <option value="">Select an option</option>
        {choices(config).map((choice) => (
          <option key={choice.value} value={choice.value}>{choice.label}</option>
        ))}
      </select>
    );
  }

  if (config.type === 'radio') {
    return (
      <div className="wizard-radio-list">
        {choices(config).map((choice) => (
          <label key={choice.value} className="wizard-radio-row">
            <input
              type="radio"
              name={fieldId}
              value={choice.value}
              checked={value === choice.value}
              onChange={() => onChange(fieldId, choice.value)}
            />
            <span>{choice.label}</span>
          </label>
        ))}
      </div>
    );
  }

  if (config.type === 'checkbox-single') {
    return (
      <label className="wizard-checkbox-single" htmlFor={id}>
        <input
          id={id}
          type="checkbox"
          checked={Boolean(value)}
          onChange={(event) => onChange(fieldId, event.target.checked)}
        />
        <span>{config.label || fieldId}</span>
      </label>
    );
  }

  return <input {...commonProps} type={config.type || 'text'} maxLength={config.max_length || undefined} />;
}

export function CharacterCount({ value, maxLength }) {
  if (!maxLength) return null;
  return <div className="wizard-count">{String(value || '').length}/{maxLength}</div>;
}
